<template>
    <rkm-modal
        ref="modal"
        title="Informações"
        :buttons="['cancel']"
        extraLarge
    >
        <Form
            :show-box-if-empty="showBoxIfEmpty"
            :motivo-atendimento="form.motivoAtendimento"
            :servicos-enfermagem="form.servicosEnfermagem"
            :observacoes-enfermagem="form.observacoesEnfermagem"
            :prescricoes-internas="form.prescricoesInternas"
            :exames-laboratoriais="form.examesLaboratoriais"
        />
    </rkm-modal>
</template>

<script>
import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        form: {
            motivoAtendimento: '',
            servicosEnfermagem: [],
            observacoesEnfermagem: [],
            prescricoesInternas: [],
            examesLaboratoriais: [],
        },
    }),
    methods: {
        open(params) {

            this.form.motivoAtendimento = params.motivoAtendimento || ''
            this.form.servicosEnfermagem = params.servicosEnfermagem || []
            this.form.observacoesEnfermagem = params.observacoesEnfermagem || []
            this.form.prescricoesInternas = params.prescricoesInternas || []
            this.form.examesLaboratoriais = params.examesLaboratoriais || []

            this.$refs.modal.show()
        }
    },
    props: {
        showBoxIfEmpty: { type: Boolean, default: false },
    }
}
</script>
